import React, { Suspense, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { Routes, Route, useSearchParams } from "react-router-dom";
import { Provider } from "react-redux";
import routes from "./routes";
import "./assets/css/App.css";
import PageNotFound from "./_shared/pages/PageNotFound";
import store from "./redux/store";
import theme from "./theme";
import { ThemeProvider } from "@mui/material";
import { useIdleTimer } from "react-idle-timer";
import { useTranslation } from "react-i18next";


function App() {
  const onIdle = () => {
    window.location.reload();
  };
  // const { isIdle, idleTimer } = useIdleTimer({ onIdle, timeout: 28800000 });
  const { isIdle, idleTimer } = useIdleTimer({ onIdle, timeout: 1800000 }); // 45 Min
  const { i18n } = useTranslation();
  const [params] = useSearchParams();
  // let hash = window.location.hash.split("ar")[1] || "";

  // const getQueryParams = (query = null) =>
  //   [...new URLSearchParams(query || hash || "").entries()].reduce(
  //     (a, [k, v]) => ((a[k] = v), a),
  //     {}
  //   );

  // useEffect(() => {
  //   if (hash && hash.length > 0) {
  //     let paramData = getQueryParams();
  //     localStorage.setItem("paramAttributes", JSON.stringify(paramData));
  //   }
  // }, []);

  useEffect(() => {
    if (params.size > 0) {
      window.localStorage.setItem(
        'paramAttributes',
        JSON.stringify(Object.fromEntries([...params]))
      )
    }
  }, [params])

  useEffect(() => {
    const lang = window.location.hash
      .split("?")[1]
      ?.split("&")
      .find((el) => el.indexOf("lang") !== -1)
      ?.slice(-2);

    if (i18n.resolvedLanguage !== lang) {
      if (lang === "en" || lang === "ar") {
        i18n.changeLanguage(lang);
      }
    }
  }, []);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route, id) => {
      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.idx} />;
      }
      return null;
    });

  return (
    // <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CAPTCHA_KEY_V3}>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <div className="App">
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                {getRoutes(routes)}
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </Suspense>
            </div>
          </ThemeProvider>
        </Provider>
      </I18nextProvider>
    // </GoogleReCaptchaProvider>
  );
}

export default App;
